import { render, staticRenderFns } from "./AddCoOwnerModal_QTDog.vue?vue&type=template&id=2c71b050"
import script from "./AddCoOwnerModal_QTDog.vue?vue&type=script&lang=ts"
export * from "./AddCoOwnerModal_QTDog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports